module.exports = __webpack_public_path__ + "static/charcoal-line-156c7d083673759cbfac2355a5ced605.svg";